import * as actionTypes from './actionTypes';
import {postData} from "../../shared/networkUtil";

export const createUserRequest = () => ({
    type: actionTypes.CREATE_USER_REQUEST
});

export const createUserSuccess = data => ({
    type: actionTypes.CREATE_USER_SUCCESS,
    data: data
});

export const createUserFail = error => ({
    type: actionTypes.CREATE_USER_FAIL,
    error
});

export const createUser = (userInfo) => dispatch => {
    dispatch(createUserRequest());
    postData("/customer/allow-exists",
        userInfo,
        response => {
            dispatch(createUserSuccess(response.data));
            localStorage.setItem('user', JSON.stringify(response.data.id))
        },
        err => {
            dispatch(createUserFail(err))
        }
    );
};

export const loadUser = () => dispatch => {
    const userString = localStorage.getItem('user');
    if (userString !== null) {
        dispatch(createUserSuccess(JSON.parse(userString)))
    }
};